// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-title-container {
  margin-bottom: 12px;
}

.editable-title-input {
  font-weight: 600;
  font-size: 2rem;
  margin-bottom: 0;
  padding: 0;
  border-bottom: none;
  outline: none;
  cursor: text;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  width: 100%;
}

/* Responsive Title Styling */
.file-heading {
  font-weight: 600 !important;
  font-size: 2rem !important;
  margin: 0;
}

/* Responsive Meta Data Container */
.meta-data-container {
  display: flex;
  align-items: center;
  gap: 8px;
  /* flex-wrap: wrap; */
}

.file-avatar {
  background-color: #87d068;
}

.meta-data-author {
  font-weight: bold;
  font-size: 14px;
}

.meta-data-details {
  margin-top: 4px;
  color: #6a737d;
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Media Queries for Responsiveness */
@media (max-width: 768px) {
  .editable-title-input,
  .file-heading {
    font-size: 1.5rem; /* Adjust title font size */
  }

  .meta-data-details {
    font-size: 13px;
    gap: 3px;
  }

  .file-avatar {
    width: 2rem;
    height: 2rem;
  }
  .meta-data-details {
    display: block;
  }
  .meta-separator {
    /* margin-left: 4px; */
    margin-right: 4px;
  }
}

@media (max-width: 576px) {
  /* .meta-data-container {
      flex-direction: column;
      align-items: flex-start;
    } */

  .editable-title-input,
  .file-heading {
    font-size: 1.2rem;
  }

  .meta-data-details {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./../editor/src/styles/EditableCard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,qCAAqC;AACrC;EACE;;IAEE,iBAAiB,EAAE,2BAA2B;EAChD;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA;EACE;;;OAGK;;EAEL;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".file-title-container {\n  margin-bottom: 12px;\n}\n\n.editable-title-input {\n  font-weight: 600;\n  font-size: 2rem;\n  margin-bottom: 0;\n  padding: 0;\n  border-bottom: none;\n  outline: none;\n  cursor: text;\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  width: 100%;\n}\n\n/* Responsive Title Styling */\n.file-heading {\n  font-weight: 600 !important;\n  font-size: 2rem !important;\n  margin: 0;\n}\n\n/* Responsive Meta Data Container */\n.meta-data-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  /* flex-wrap: wrap; */\n}\n\n.file-avatar {\n  background-color: #87d068;\n}\n\n.meta-data-author {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.meta-data-details {\n  margin-top: 4px;\n  color: #6a737d;\n  font-size: 14px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n/* Media Queries for Responsiveness */\n@media (max-width: 768px) {\n  .editable-title-input,\n  .file-heading {\n    font-size: 1.5rem; /* Adjust title font size */\n  }\n\n  .meta-data-details {\n    font-size: 13px;\n    gap: 3px;\n  }\n\n  .file-avatar {\n    width: 2rem;\n    height: 2rem;\n  }\n  .meta-data-details {\n    display: block;\n  }\n  .meta-separator {\n    /* margin-left: 4px; */\n    margin-right: 4px;\n  }\n}\n\n@media (max-width: 576px) {\n  /* .meta-data-container {\n      flex-direction: column;\n      align-items: flex-start;\n    } */\n\n  .editable-title-input,\n  .file-heading {\n    font-size: 1.2rem;\n  }\n\n  .meta-data-details {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
